const { Stack } = require('./src/stack');

exports.Stack = Stack;
